import { Module } from 'vuex';
import { ApplicationFormWorkAccountState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced: boolean = true;

export const state: ApplicationFormWorkAccountState = {
    currentSamls: undefined,
    currentSamlCount: 0,
    currentSamlSkip: undefined,
    current_saml: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    current_saml_skip: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
};

export const applicationFormWorkAccount: Module<ApplicationFormWorkAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
